export class RenewablesService {
  constructor(http) {
    this.http = http;
  }

  async summary(buildingIds, beginDate, endDate, disableIdealCurve) {
    this.summaryParams = {
      buildingIds,
      beginDate: beginDate.format('YYYY-MM-DD'),
      endDate: endDate.format('YYYY-MM-DD'),
      disableIdealCurve
    };
    return this.http.post(`/renewables/summary`, this.summaryParams);
  }
  async summaryCSV() {
    if (!this.summaryParams) return;
    return this.http.post(
      `/renewables/summary?outputType=Csv`,
      this.summaryParams
    );
  }

  async avgDailySolarChart(buildingIds, beginDate, endDate, disableIdealCurve) {
    this.avgDailySolarChartParams = {
      buildingIds,
      beginDate: beginDate.format('YYYY-MM-DD'),
      endDate: endDate.format('YYYY-MM-DD'),
      disableIdealCurve
    };
    return this.http.post(
      `/renewables/average-daily-solar-generation`,
      this.avgDailySolarChartParams
    );
  }
  async avgDailySolarChartCSV() {
    if (!this.avgDailySolarChartParams) return;
    return this.http.post(
      `/renewables/average-daily-solar-generation?outputType=Csv`,
      this.avgDailySolarChartParams
    );
  }

  async siteEnergySourceChart(buildingIds, beginDate, endDate, aliasId = null) {
    this.siteEnergySourceChartParams = {
      buildingIds,
      beginDate: beginDate.format('YYYY-MM-DD'),
      endDate: endDate.format('YYYY-MM-DD'),
    };
    if (aliasId == null) {
      return this.http.post(
        `/renewables/site-energy-source-comparison`,
        this.siteEnergySourceChartParams
      );
    } else {
      return this.http.post(
        `/renewables/site-energy-source-comparison?aliasNameSetId=${aliasId}`,
        this.siteEnergySourceChartParams
      );
    }
  }
  async siteEnergySourceChartCSV() {
    if (!this.siteEnergySourceChartParams) return;
    return this.http.post(
      `/renewables/site-energy-source-comparison?outputType=Csv`,
      this.siteEnergySourceChartParams
    );
  }

  async solarPowerGenChart(buildingIds, beginDate, endDate, disableIdealCurve) {
    this.solarPowerGenChartParams = {
      buildingIds,
      beginDate: beginDate.format('YYYY-MM-DD'),
      endDate: endDate.format('YYYY-MM-DD'),
      disableIdealCurve
    };
    return this.http.post(
      `/renewables/solar-power-generation`,
      this.solarPowerGenChartParams
    );
  }
  async solarPowerGenChartCSV() {
    if (!this.solarPowerGenChartParams) return;
    return this.http.post(
      `/renewables/solar-power-generation?outputType=Csv`,
      this.solarPowerGenChartParams
    );
  }
}
